/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("registerRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register", {
        url: "/register",
        views: {
            "": {
                template: '<div class="view_head_register" ui-view="header"></div>' +
                    '<div class="">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@register": {
                templateUrl: 'header/headerLogin_tpl.html',
                controller: 'headerLoginCtrl'
            },
            "main@register": {
                templateUrl: "./login/register/register_tpl.html",
                controller: "registerCtrl"
            }
        }
    });
}]);